export const pageLoadComplete = 'page-load-complete'

enum EventType {
  SearchButtonSelected = 'search-btn-clicked',
  SearchTrendShown = 'search_trend_shown',
  SearchCategoriesShown = 'search_categories_shown',
  SearchBarSelected = 'search_bar_clicked',
  SearchInputStart = 'search-input-start',
  SearchResultSelected = 'search_result_clicked',
  SearchBackButtonSelected = 'search_back_btn_clicked',
  SearchDismissed = 'search_dismissed',
  // Header - Desktop
  DesktopCategoriesShown = 'desktop-top-bar-categories-shown',
  DesktopCategorySelect = 'desktop-top-bar-category-clicked',
  // A2HS Card
  A2HSCardShown = 'a2hs-ui-card-visible',
  A2HSCardSelect = 'a2hs-card-clicked',
  // Notification Card
  NotificationCardShown = 'notifications-ui-card-visible',
  NotificationCardSelection = 'notifications-ui-card-clicked',
  // Game Categories
  GameCategoryPageChanged = 'game-category-game-page-changed',
  GameCategoryViewAll = 'game-category-view-all-btn-clicked',
  GameCategorySeeMoreBtnClicked = 'game-category-see-more-btn-clicked',
  // Game Category on Desktop Sidebar
  GameCategorySelected = 'game-category-clicked',
  // Bottom Sheet
  GamesBottomSheetLoad = 'games-bottom-sheet-load',
  GamesBottomSheetFavourited = 'games-bottom-sheet-favorited',
  GamesBottomSheetPlaySelected = 'games-bottom-sheet-play-game-clicked',
  GamesBottomSheetAboutSelected = 'games-bottom-sheet-about-game-clicked',
  //Game Details Page
  GameDetailPageLoad = 'game-detail-page-load',
  GameDetailPageFavorited = 'game-detail-page-favorited',
  GameDetailPageGameRated = 'game-detail-page-game-rated',
  GameDetailPagePlayBtnSelected = 'game-detail-page-play-button-clicked',
  // Swipeable Side Menu
  SwipeableSideMenuOpen = 'side-menu-btn-clicked',
  SwipeableMenuGameCategorySelected = 'side-menu-game-category-clicked',
  // Firework
  // FireworkError = 'firework-widget-not-displayed-error',
  // FireworkRenderStarted = 'firework-widget-render-started',
  // FireworkContentReady = 'firework-widget-content-ready',
  // FireworkThumbnailViewed = 'firework-widget-thumbnail-viewed',
  // FireworkThumbnailLoaded = 'firework-widget-thumbnail-loaded',
  // FireworkThumbnailClicked = 'firework-widget-thumbnail-clicked',
  // FireworkVideoLoaded = 'firework-video-loaded',
  // FireworkVideoStart = 'firework-video-start',
  // FireworkVideo25pctViewed = 'firework-video-25pct-viewed',
  // FireworkVideo50pctViewed = 'firework-video-50pct-viewed',
  // FireworkVideo75pctViewed = 'firework-video-75pct-viewed',
  // FireworkVideo90pctViewed = 'firework-video-atleast-90pct-viewed',
  // FireworkVideoSessionEnd = 'firework-video-session-end',
  // FireworkVideoCTAClicked = 'firework-video-cta-clicked',
  // AD Events
  DesktopAdSelected = 'desktop-ad-clicked',
  DesktopAdError = 'desktop-ad-error',
  DesktopAdFilled = 'desktop-ad-filled',
  DesktopAdNoFill = 'desktop-ad-no-fill',
  DesktopAdRequested = 'desktop-ad-requested',
  DesktopAdShown = 'desktop-ad-shown',
  MobileAdSelected = 'mobile-ad-clicked',
  MobileAdError = 'mobile-ad-error',
  MobileAdFilled = 'mobile-ad-filled',
  MobileAdNoFill = 'mobile-ad-no-fill',
  MobileAdRequested = 'mobile-ad-requested',
  MobileAdShown = 'mobile-ad-shown',
  AdRequested = 'ad-requested',
  // Quizzop
  QuizzopCardSelected = 'quizzop-card-click',
  // Product Icon
  TopBarIconPlacementClicked = 'top-bar-icon-placement-clicked',

  // IntroScreenCategoryOnePicked = 'intro-screen-1-category-picked',
  // IntroScreenCategoryTwoPicked = 'intro-screen-2-category-picked',
  // CategoryStartPlayingBtnSelected = 'start-playing-screen-play-btn-clicked',
  // Page-view
  PageView = 'page-name',
  // Mobile layout event changes
  HomeIconClicked = 'home-icon-clicked',
  MenuCategoryClicked = 'menu-category-clicked',
  SideMenuBtnClicked = 'side-menu-btn-clicked',
  SideMenuGameCategoryClicked = 'side-menu-game-category-clicked',
  LayoutShown = 'layout-shown',
  LayoutScrolled = 'layout-scrolled',
  GameCardClicked = 'game-card-clicked',
  GameCardFavourited = 'game-card-favorited',
  PlayRandomBtnClicked = 'play-random-btn-clicked',
  // Intro flow events
  LangaugeFilterCLicked = 'language-filter-clicked',
  LanguageSelected = 'language-selected',
  HandGestureShown = 'hand-gesture-shown',
  // PWA
  PWAInstalled = 'pwa-installed',
  // Comet - Domino UI events
  HomeBackButtonClicked = 'back-to-home-btn-clicked',
  HoveringIconShowed = 'hovering-icon-shown',
  HoveringIconClicked = 'hovering-icon-clicked',
  DominoBottomSheetOpened = 'domino-bottom-sheet-opened',
  DominoGameCardClicked = 'domino-game-card-clicked',
  DominoGameFavorited = 'domino-game-favorited',
  GameplayerFullScreenClicked = 'gameplayer-fullscreen-clicked',
  // Game play events
  GamePlayStart = 'game-play-start',
  GamePlayOver = 'game-play-over',
  GameLoadingComplete = 'game-loading-complete',
  GamePlayRetry = 'game-play-retry',
  GamePlayLevelUp = 'game-play-levelup',
  GameLoadingStart = 'game-loading-start',
  GameLoadingDelayed = 'game-loading-delayed',
}

export default EventType
